import { hash } from '@ember/helper';
import { t } from 'ember-intl';
import Component from '@glimmer/component';
import PslfDashboardCardInfo from 'tio-employee/components/pslf/dashboard/card-info';
import PslfDashboardTodo from 'tio-employee/components/pslf/dashboard/todo';
import transitionTo from 'ember-router-helpers/helpers/transition-to';
import { on } from '@ember/modifier';
import Button from 'tio-reimagined/components/button';
import { PhUploadSimple } from 'ember-phosphor-icons';
import type { ObservableSource } from 'tio-employee/services/observability';

export interface ProvideRepaymentPlanTodoSignature {
  Args: {
    source?: ObservableSource;
  };
  Element: HTMLElement;
}

export default class ProvideRepaymentPlanTodoComponent extends Component<ProvideRepaymentPlanTodoSignature> {
  get uploadRoute() {
    return 'authenticated.observability.upload';
  }

  get uploadQueryParams() {
    return { source: this.args.source ?? 'pslf', providers: 'nslds,statement' };
  }

  <template>
    <PslfDashboardTodo @title={{t "recommendations.provide_repayment_plan"}} @isComplete={{false}}>
      <:leftHeader>
        <div class="w-6"></div>
      </:leftHeader>
      <:body>
        <PslfDashboardCardInfo
          @icon={{PhUploadSimple}}
          @text={{t "recommendations.provide_repayment_plan_description"}}
          class="w-fit"
        />
      </:body>
      <:actions>
        <Button
          {{on "click" (transitionTo this.uploadRoute (hash queryParams=this.uploadQueryParams))}}
          @appearance="outlined"
          @intent="primary"
        >
          {{t "recommendations.upload_my_student_data"}}
        </Button>
      </:actions>
    </PslfDashboardTodo>
  </template>
}
